import axios from "axios";

const API_BASE = `${process.env.REACT_APP_BACKEND_URL || ""}/api`;

export const api = axios.create({ baseURL: API_BASE, timeout: 15000 });

export const formatDate = (iso) => {
  try {
    return new Date(`${iso}T00:00:00`).toLocaleDateString("en-US", {
      month: "long",
      day: "numeric",
      year: "numeric",
    });
  } catch {
    return iso;
  }
};

export const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  if (window.__lenis) window.__lenis.scrollTo(el, { offset: -96, duration: 1.2 });
  else el.scrollIntoView({ behavior: "smooth" });
};
